import React from 'react'
import {graphql} from 'gatsby'
import Img from 'gatsby-image'
import BackgroundImage from 'gatsby-background-image'

import Layout from '../components/Layout'

//import LayoutTufan from '../components/layouttufan'

import SEO from '../components/seo'

// import tufanHero from '../../content/assets/tufan-io-hero.jpg'
// import tufanConfigure from '../../content/assets/tufan-configure.png'
// import tufanDraw from '../../content/assets/tufan-draw.png'
// import tufanDeploy from '../../content/assets/tufan-deploy.png'

// No need to import this; this file is imported in gatsby-browser.js
// import '../css/style.css' 
//import tufanStyles from '../components/tufanstyles.module.css'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faUser, faEdit, faThumbsUp} from '@fortawesome/free-regular-svg-icons'
//import {faChartBar, faFileImage} from '@fortawesome/free-regular-svg-icons'
import {faListAlt, faCheckSquare} from '@fortawesome/free-regular-svg-icons'
import {faRedo, faShieldAlt, faGlobe, faAward} from '@fortawesome/free-solid-svg-icons'

// import Container from '../components/container'

//function Home(){
const Home = ({location, data}) => {
    const simpleText= <p><span className="font-medium">µ</span> our service editor, is the world's simplest way to build manageable, reproducible cloud services, micro or not.
        <br/>Just <span className="font-medium">Draw &#x26; Deploy</span>. Even slicing bread is more effort.</p>
    
    const reproducibleText = <p>Each service generates a <span className="font-medium">reproducible deployment script</span>. You get strong type-safety, stable versioning, 
        release mechanics and all around peace-of-mind for free.</p>
 
    const safeText = <p><span className="font-medium">Least-privilege access model</span> is elevated to a first-class design capability, making your architecture that much more secure. 
        You can customize it, but with sensible defaults, you mostly don't have to worry.</p>
    
    const composableText = <p>A tufan-component, is either a basic unit of composition or the composition itself. This allows composing complex 
        functionality, while keeping a lid on the management headaches.</p>
    
    const openSourceText = <p>All generated scripts are open source. We hate lock-in as much as you. Use our components, build your own or adapt others - 
        the cloud is your playground. (pssst... then is the sky no longer the limit?)</p>
    
    const manageabilityText = <p>(Coming soon) You can monitor the performance, security and costs of your infrastructure on a single configuration model.</p>

    const tufanIconBlueColor = "#90CDF4";

    return(
        <div>
            <Layout location={location}>
            <SEO
                title="Tufan.io replicated site in Gatsby"
                keywords={[`tufan.io`, `gatsby`, `blog`]}
            />
            {/* <Container> */}
            {/* bg-white as the tufanHeroImg is white. bg-gray-100 doesn't work */}
            {/* I wanted to use <body> </body> tag here, but get an error saying body cannot appear as child of div          */}
            <div className="bg-white"> 
            
            {/* <div className="tufan-hr ml-10 mb-2"></div> */}

            <BackgroundImage
                fluid={data.tufanHeroImg.childImageSharp.fluid} 
                // https://github.com/gatsbyjs/rfcs/blob/prefetch-images/text/0000-support-prefetching-images.md
                critical
                alt="Headphones and coffee and a pencil"    
            >

                <div className="bg-transparent tufan-hero-text">

                    {/* Needed this text to get the right size of the background image */}
                    {/* <h1 className="bg-transparent text-center text-white mt-20">tufan.io</h1> */}
                    <br/>
                    <div className="bg-transparent tufan-bold-text-home text-center text-5xl mt-20">
                        AWS gives you scale, <br/>we make it simple.
                    </div>
                    <div className="bg-transparent tufan-logo text-center mt-6">
                        tufan.io
                    </div>
                    {/* <br/><br/><br/><br/><br/> */}
                    
                    <div className="mt-16 mb-12 text-center">
                    <div>
                        <button className="tufan-btn mr-2 px-4 py-2 text-sm font-medium">Learn more</button>            
                        <button className="tufan-btn tufan-btn-color-reverse ml-2 uppercase px-4 py-2 text-sm tracking-tight">Get Priority Access</button>
                    </div>
                </div>

                </div>

            </BackgroundImage>
            {/* <div className="tufan-hr ml-10 mb-2"></div> */}

                <div className="tufan-bold-text-home text-center mt-48">
                    <span id="Howitworks">How It Works</span>
                </div>
                
                
                <div className="flex flex-row justify-around mt-12">
                    
                    <div className="w-2/5 px-12 pt-20 max-w-md">
                        <div className="tufan-bold-text-home"> DRAW </div>
                        <p className="tufan-text-content mt-4">You draw the desired architecture. We interpret much of the configuration
                            from the link context.</p>
                        <p className="tufan-text-content mt-4">
                            Each component in the library is released under an
                            Apache-2.0 license. As is the final template. 
                        </p>
                    </div>
                    <div className="w-3/5">
                        <Img fluid={data.tufanDrawImg.childImageSharp.fluid} alt="Component Drawing Tool" style={{ flex:1 }}/>               
  
                        {/* <img src={tufanDraw} alt="Component Drawing Tool"/> */}
                    </div>
                </div>       
                
                <div className="flex flex-row justify-around mt-8">
                    <div className="w-3/5">
                        <Img fluid={data.tufanConfigureImg.childImageSharp.fluid} alt="Configured Application" style={{ flex:1 }}/>
                        {/* <img src={tufanConfigure} alt="Configured Application"/> */}
                    </div>
                    <div className="w-2/5 px-12 pt-20 max-w-md">
                        <div className="tufan-bold-text-home">CONFIGURE</div>
                        <p className="tufan-text-content mt-4">
                            Tufan.io brings the notion of convention-over-configuration to dev-ops.
                        </p>
                        <p className="tufan-text-content mt-4">
                            With sensible defaults, configuration is mostly reduced to just hooking up your git repos.
                        </p>
                    </div>
                </div>

                <div className="flex flex-row justify-around mt-8 mb-12">
                    
                    <div className="w-2/5 px-12 pt-20 max-w-md">
                        <div className="tufan-bold-text-home"> DEPLOY </div>
                        <p className="tufan-text-content mt-4">You can download the generated script and do as you please, or click the deploy 
                            button and manage the project from our UI.
                        </p>
                        <p className="tufan-text-content mt-4">
                            Couldn’t be simpler.
                        </p>
                    </div>
                    <div className="w-3/5">
                        <Img fluid={data.tufanDeployImg.childImageSharp.fluid} alt="Deployment in Progress" style={{ flex:1 }}/>               

                        {/* <img src={tufanDeploy} alt="Deployment in Progress"/> */}
                    </div>
                </div>       

                
                <div className="tufan-bold-text-home text-center text-5xl mt-40">
                <span id="Features">
                    Reproducible AWS deployments<br/>
                    @ the speed of thought
                </span>
                </div>
                {/* <div className={`${tufanStyles.textHome} ${tufanStyles.myBold}`} >SIMPLE </div> */}    
                
                <div className="flex flex-row justify-around mt-12">
                <div className="w-1/3 max-w-md">
                    
                    <div className="flex flex-row justify-start">
                        <div>
                        <span className="pl-12 pr-4"> <FontAwesomeIcon icon={faUser} size="2x" color={tufanIconBlueColor}/> </span>
                        </div>
                        <div className="tufan-text-content text-sm uppercase font-medium mt-1">Simple
                        </div>
                    </div>
                    <div className="tufan-text-content px-12 pt-4">{simpleText}</div>
                </div>
                <div className="w-1/3 max-w-md">
                    <div className="flex flex-row justify-start">
                        <span className="pl-12 pr-4"> <FontAwesomeIcon icon={faRedo} size="2x" color={tufanIconBlueColor}/></span>
                        <div className="tufan-text-content text-sm uppercase font-medium mt-1">Reproducible
                        </div>
                    </div>
                    <div className="tufan-text-content max-w-md px-12 pt-4"> {reproducibleText} </div>
                </div>
                <div className="w-1/3 max-w-md">
                    <div className="flex flex-row justify-start">
                        <span className="pl-12 pr-4"> <FontAwesomeIcon icon={faShieldAlt} size="2x" color={tufanIconBlueColor}/></span>
                        <div className="tufan-text-content text-sm uppercase font-medium mt-1">Safe
                        </div>
                    </div>
                    <div className="tufan-text-content max-w-md px-12 pt-4"> {safeText} </div>
                </div>
                </div>

                <div className="flex flex-row justify-around mt-12">
                <div className="w-1/3 max-w-md">
                    <div className="flex flex-row justify-start">
                        <span className="pl-12 pr-4"><FontAwesomeIcon icon={faEdit} size="2x" color={tufanIconBlueColor}/></span>
                        <div className="tufan-text-content text-sm uppercase font-medium mt-1">Composable
                        </div>
                    </div>
                    <div className="tufan-text-content max-w-md px-12 pt-4"> {composableText} </div>
                </div>
                <div className="w-1/3 max-w-md">
                    <div className="flex flex-row justify-start">
                    <span className="pl-12 pr-4"><FontAwesomeIcon icon={faThumbsUp} size="2x" color={tufanIconBlueColor}/></span>
                    <div className="tufan-text-content text-sm uppercase font-medium mt-1">Open Source
                    </div>
                    </div>
                    <div className="tufan-text-content max-w-md px-12 pt-4"> {openSourceText} </div>
                </div>
                <div className="w-1/3 max-w-md">
                    <div className="flex flex-row justify-start">
                        {/* <span className="pl-12 pr-4"><FontAwesomeIcon icon={faChartBar} size="2x" color={tufanIconBlueColor}/></span> */}
                        {/* <span className="pl-12 pr-4"><FontAwesomeIcon icon={faFileImage} size="2x" color={tufanIconBlueColor}/></span> */}
                        <span className="pl-12 pr-4"><FontAwesomeIcon icon={faListAlt} size="2x" color={tufanIconBlueColor}/></span>  
                        <div className="tufan-text-content text-sm uppercase font-medium mt-1">Manageability
                        </div>
                    </div>
                    <div className="tufan-text-content max-w-md px-12 pt-4"> {manageabilityText} </div>
                </div>
                </div>


                <div className="tufan-bold-text-home text-center mt-40">
                <span id="Pricing">Pricing</span>
                </div>
            
                <div className="flex flex-row justify-center mt-12">
                    <div className="max-w-xs pr-10">
                        <div className="flex flex-row justify-start mb-4">
                           <span className="pl-12 pr-4"><FontAwesomeIcon icon={faListAlt} size="2x" color={tufanIconBlueColor}/></span> 
                           <p className="tufan-text-content text-lg mt-1">Management UI</p>
                        </div>
                        <div className="tufan-hr ml-10 mb-2"></div>

                        <div className="flex flex-row justify-start mb-4">
                            <span className="pl-12 pr-3"><FontAwesomeIcon icon={faEdit} size="2x" color={tufanIconBlueColor}/></span>
                            <p className="tufan-text-content text-lg mt-1">Deployment script</p>
                        </div>
                        <div className="tufan-hr ml-10 mb-2"></div>
                        
                        <div className="flex flex-row justify-start mb-4">
                            <span className="pl-12 pr-4"><FontAwesomeIcon icon={faGlobe} size="2x" color={tufanIconBlueColor}/></span>
                            <p className="tufan-text-content text-lg mt-1">30 Day Free Trial</p>
                        </div>
                        <div className="tufan-hr ml-10 mb-2"></div>

                        <div className="flex flex-row justify-start mb-4">
                            <span className="pl-12 pr-6"><FontAwesomeIcon icon={faAward} size="2x" color={tufanIconBlueColor}/></span>
                            <p className="tufan-text-content text-lg mt-1">Freedom</p>
                        </div>
                        <div className="tufan-hr ml-10 mb-2"></div>

                        <div className="flex flex-row justify-start">
                            <span className="pl-12 pr-5"><FontAwesomeIcon icon={faCheckSquare} size="2x" color={tufanIconBlueColor}/></span>
                            <p className="tufan-text-content text-lg mt-1">Peace of mind</p>  
                        </div>
                        
                    </div>
                    <div className="mb-40 pl-10">
                        <p className="tufan-text-content text-3xl">$10/project/month</p>
                        <div className="tufan-text-content max-w-sm mt-6">
                            <p>Too good to be true you say?</p>
                            <p className="mt-4">
                                Well, it's 2020. We think manageability and security should be
                                the birth-right of every cloud service.
                            </p>
                            <p className="mt-4">We're happy to do our part. 
                            <span className="font-medium">Go forth and create()</span>
                            </p>
                        </div>
                        <button className="tufan-btn px-6 py-3 text-sm tracking-tight uppercase font-medium mt-6">
                            Signup for priority access  &#9658;
                        </button>            
                    </div>
                </div>
            {/* </Container> */}
            </div> {/* bg-white */}
            </Layout>
        </div>
    )
}
    
export default Home

// This is the maxWidth of tufanHeroImg
//            fluid(maxWidth: 1920) {

export const fluidImage = graphql `
    fragment fluidImage on File {
        childImageSharp {
            fluid {
                ...GatsbyImageSharpFluid
            }
        }
    }
`;

export const pageQuery = graphql`
    query {
        tufanHeroImg: file (relativePath: {eq: "tufan-io-hero.jpg"}){
            ...fluidImage
        }

        tufanDrawImg: file (relativePath: {eq: "tufan-draw.png"}){
            ...fluidImage
        }

        tufanConfigureImg: file (relativePath: {eq: "tufan-configure.png"}){
            ...fluidImage
        }

        tufanDeployImg: file (relativePath: {eq: "tufan-deploy.png"}){
            ...fluidImage
        }
    }
`;

// tufanDeployImg: file (relativePath: {eq: "tufan-deploy.png"}){
//     childImageSharp{
//         fluid(maxWidth: 1280){
//             ...GatsbyImageSharpFluid
//         }
//     }
// }